import { PUP_DISPLAY_NAME, TRELLO_TOKEN_KEY, DASHER_TOKEN } from "./config"
import { getShowAuthorization } from "./show-authorization/capability"
import { getAuthorizationStatus } from "./authorization-status/capability"

window.TrelloPowerUp.initialize(
  {
    "board-buttons": async (t: TrelloIframe) => {
      const { authorized } = await getAuthorizationStatus(t)
      if (!authorized) return []
      const origin = window.location.origin
      return [
        {
          text: "Gantt View",
          // `dark` is shown in Trello's dark mode (light icon), `light` in light mode (dark icon).
          icon: {
            dark: `${origin}/icon-dark.svg`,
            light: `${origin}/icon-light.svg`,
          },
          callback: (t: TrelloIframe) =>
            t.modal({
              url: "./gantt.html",
              title: "Gantt View",
              fullscreen: true,
            }),
        },
      ]
    },
    "on-enable": (t: TrelloIframe) =>
      t.modal({
        url: "./on-enable.html",
        title: "Gantt View",
        height: 350,
      }),
    "remove-personal-settings": (t: TrelloIframe) =>
      Promise.all([
        t.remove("member", "private", TRELLO_TOKEN_KEY),
        t.remove("member", "private", DASHER_TOKEN)
      ]),
    "show-authorization": (t: TrelloIframe) => getShowAuthorization(t),
    "authorization-status": async (t: TrelloIframe) => await getAuthorizationStatus(t),
    "show-settings": (t: TrelloIframe) =>
      t.modal({
        url: "./show-settings.html",
        title: "Blue Dasher Subscription",
        fullscreen: true,
      }),
  },
  {
    appName: PUP_DISPLAY_NAME,
    appKey: import.meta.env.VITE_POWERUP_APP_KEY,
  }
)
